const address = `http://127.0.0.1:10000`

const heartbeat = async () => {
    let startReq = false
    let counter = 0;
    return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
            try {
                const res = await fetch(`${address}/heartbeat`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })

                if(res.ok) {
                    resolve(true)
                    clearInterval(interval)
                }
            }
            catch (e) {
                if(!startReq)
                {
                    startReq = true
                    window.open(`rasreviewautomation://start_app`)
                }
            }
        }, 500)
    })
}

const run_project = async (data) => {
    await heartbeat()
    const res = await fetch(`${address}/run-output`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })

    if(res.ok) {
        return  await res.json()
    }

    return false
}

const LocalService = {
    run_project
}

export default LocalService